/**
 * The invitation token an unauthenticated visitor parks before being sent to the
 * login screen, so the session that comes back can still redeem it.
 *
 * `AcceptInvitationView` parks it, `LoginView` reads it to decide where to send
 * the user afterwards, and the auth store takes it once the user is
 * authenticated. Keeping the key in one place stops those three from drifting
 * apart on a magic string.
 */
const PENDING_INVITATION_KEY = 'pendingInvitationToken'

/** Park an invitation token for replay once the visitor is authenticated. */
export function parkPendingInvitation(token: string): void {
  sessionStorage.setItem(PENDING_INVITATION_KEY, token)
}

/** Whether a token is parked, without consuming it. */
export function hasPendingInvitation(): boolean {
  return sessionStorage.getItem(PENDING_INVITATION_KEY) !== null
}

/**
 * Read the parked token and clear it, so a replay is attempted at most once per
 * sign-in and a failed attempt cannot loop.
 */
export function takePendingInvitation(): string | null {
  const token = sessionStorage.getItem(PENDING_INVITATION_KEY)
  if (token !== null) {
    sessionStorage.removeItem(PENDING_INVITATION_KEY)
  }
  return token
}
